// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".platform-admin-list .platform-admin-toolbar {\n  background: #fff;\n  padding: 16px 20px 0;\n}\n.platform-admin-list .el-dialog__wrapper {\n  display: inherit;\n}", ""]);
// Exports
module.exports = exports;
